import { render, staticRenderFns } from "./RelatedServiceCompliance.vue?vue&type=template&id=2c1af088&"
import script from "./RelatedServiceCompliance.vue?vue&type=script&lang=js&"
export * from "./RelatedServiceCompliance.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports